import { render, staticRenderFns } from "./MyQuestion.vue?vue&type=template&id=7fbc8bc6&scoped=true"
import script from "./MyQuestion.vue?vue&type=script&lang=js"
export * from "./MyQuestion.vue?vue&type=script&lang=js"
import style0 from "./MyQuestion.vue?vue&type=style&index=0&id=7fbc8bc6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7fbc8bc6",
  null
  
)

export default component.exports